import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource-variable/dm-sans/standard.css'
import '@fontsource-variable/dm-sans/standard-italic.css'
import '@fontsource/instrument-serif/400.css'
import '@fontsource/instrument-serif/400-italic.css'
import 'katex/dist/katex.min.css'
import './index.css'
import App from './App.tsx'
import AppUnavailable from './pages/AppUnavailable.tsx'
import { RouteContextProvider } from './contexts/route-context.tsx'
import { AiSidebarProvider } from './contexts/ai-sidebar-context.tsx'
import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from 'convex/react-clerk'
import { ClerkProvider, useAuth } from "@clerk/react"
import { AppContextProvider } from './contexts/app-context.tsx'
import { ThemeProvider } from './contexts/theme-context.tsx'
import { CoursesProvider } from "./providers/CoursesProvider";
import { AiFeatureFlagsProvider } from "./contexts/ai-feature-flags-context";
import { GeneralFeatureFlagsProvider } from "./contexts/general-feature-flags-context";
import { isAppAvailable } from "./lib/app-availability-flag";
import { UsageProvider } from "./contexts/usage-context.tsx";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL);
const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

function LurnaAppTree() {
  return (
    <ClerkProvider
      publishableKey={clerkPublishableKey}
      appearance={
        {
          options: { socialButtonsVariant: 'blockButton', socialButtonsPlacement: 'bottom' },
          captcha: { theme: 'light', size: 'flexible' }
        }
      }
      signInUrl="/login"
      signUpUrl="/signup"
      afterSignOutUrl="/login"
      signInFallbackRedirectUrl="/"
    >
      <ThemeProvider defaultTheme="light">
        <BrowserRouter>
          <ConvexProviderWithClerk useAuth={useAuth} client={convex}>
            <UsageProvider>
              <AiFeatureFlagsProvider>
                <GeneralFeatureFlagsProvider>
                  <CoursesProvider>
                    <AppContextProvider>
                      <AiSidebarProvider>
                        <RouteContextProvider>
                          <App />
                        </RouteContextProvider>
                      </AiSidebarProvider>
                    </AppContextProvider>
                  </CoursesProvider>
                </GeneralFeatureFlagsProvider>
              </AiFeatureFlagsProvider>
            </UsageProvider>
          </ConvexProviderWithClerk>
        </BrowserRouter>
      </ThemeProvider>
    </ClerkProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAppAvailable(import.meta.env) ? (
      <LurnaAppTree />
    ) : (
      <ClerkProvider
        publishableKey={clerkPublishableKey}
        appearance={
          {
            options: { socialButtonsVariant: 'blockButton', socialButtonsPlacement: 'bottom' },
            captcha: { theme: 'light', size: 'flexible' }
          }
        }
        signInUrl="/login"
        signUpUrl="/signup"
        afterSignOutUrl="/login"
        signInFallbackRedirectUrl="/"
      >
        <ThemeProvider defaultTheme="light">
          <AppUnavailable />
        </ThemeProvider>
      </ClerkProvider>
    )}
  </StrictMode>
)
